export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Greek-72ba89dbfc031f7449f9688cc195b40a.woff";